/* @flow */
import React from 'react';
import { Input } from 'antd';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Loader from '../Loader';

type Props = {
  address?: string,
  placeholder: string,
  size: string,
  className?: string,
  onAddressSelect: (address: string) => void,
  setPropertyCoordinates: (lat: number, lng: number) => void,
};

type State = {
  address?: string,
};

export default class LocationSearch extends React.Component<Props, State> {
  static defaultProps = {
    address: '',
    className: '',
    size: 'default',
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      address: props.address,
    };
  }

  handleAddressSelect = (address: string) => {
    geocodeByAddress(address)
      .then((results) => {
        this.setState({ address: results[0].formatted_address });
        if (this.props.setPropertyCoordinates) {
          this.props.setPropertyCoordinates(results[0].geometry.location.lat(), results[0].geometry.location.lng());
        }
        return getLatLng(results[0]);
      })
      .catch((error) => {
        throw new Error(error);
      });
  };

  componentDidMount() {
    if (this.state.address) {
      this.handleAddressSelect(this.state.address);
    }
  }

  handleChange = (address: string) => {
    this.setState({ address });
  };

  onError = (status: string, clearSuggestions: Function) => {
    console.log('Google Maps API returned error with status: ', status);
    clearSuggestions();
  };

  render() {
    const { address } = this.state;
    const { placeholder, onAddressSelect, size, className } = this.props;

    return (
      <PlacesAutocomplete
        onChange={this.handleChange}
        onSelect={this.handleAddressSelect}
        onError={this.onError}
        value={address}
      >
        {({ getInputProps, getSuggestionItemProps, suggestions, loading }) => (
          <>
            <Input
              {...getInputProps({
                id: 'address-input',
              })}
              size={size}
              className={className}
              placeholder={placeholder}
              onSelect={onAddressSelect}
            />
            <div>
              {loading ? <Loader size="small" /> : null}
              {suggestions.map((suggestion) => {
                const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                const style = suggestion.active
                  ? { backgroundColor: '#e6f7ff', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };

                const spread = {
                  ...getSuggestionItemProps(suggestion, {}),
                  className,
                  style,
                };

                return (
                  <div {...spread} key={suggestion.index}>
                    <div>{suggestion.description}</div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </PlacesAutocomplete>
    );
  }
}
